// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Alert = require("../common/Components/Alert.bs.js");
var React = require("react");
var Scalars = require("../../scalars/Scalars.bs.js");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Core__Int = require("@rescript/core/src/Core__Int.bs.js");
var Formality = require("../../vendor/re-formality/Formality.bs.js");
var Breadcrumbs = require("../common/Components/Breadcrumbs.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Form__Input = require("../../uikit/reason/atoms/Form/Form__Input.bs.js");
var Form__Label = require("../../uikit/reason/atoms/Form/Form__Label.bs.js");
var FormalityUI = require("../common/Form/FormalityUI.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var Formality__ReactUpdate = require("../../vendor/re-formality/Formality__ReactUpdate.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var MarketingProfileSubpages = require("./MarketingProfileSubpages.bs.js");
var UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
var TeamMarketingProfileBasicInfoSettingsQuery_graphql = require("../../__generated__/TeamMarketingProfileBasicInfoSettingsQuery_graphql.bs.js");
var TeamMarketingProfileBasicInfoSettingsMutation_graphql = require("../../__generated__/TeamMarketingProfileBasicInfoSettingsMutation_graphql.bs.js");
var TeamMarketingProfileBasicInfoSettings_form_agentMarketingProfile_graphql = require("../../__generated__/TeamMarketingProfileBasicInfoSettings_form_agentMarketingProfile_graphql.bs.js");

var validators_teamSize = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param) {
      var teamSize = param.teamSize;
      if (teamSize === "") {
        return {
                TAG: "Ok",
                _0: undefined
              };
      }
      var n = Core__Int.fromString(teamSize, undefined);
      if (n !== undefined) {
        return {
                TAG: "Ok",
                _0: n
              };
      } else {
        return {
                TAG: "Error",
                _0: "NotANumber"
              };
      }
    })
};

var validators_website = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param) {
      var website = param.website;
      if (website === "") {
        return {
                TAG: "Ok",
                _0: undefined
              };
      }
      var e = Scalars.$$URL.fromString(website);
      if (e.TAG === "Ok") {
        return {
                TAG: "Ok",
                _0: Caml_option.some(e._0)
              };
      } else {
        return {
                TAG: "Error",
                _0: "InvalidURL"
              };
      }
    })
};

var validators_brokerage = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param) {
      var brokerage = param.brokerage;
      if (brokerage === "") {
        return {
                TAG: "Ok",
                _0: undefined
              };
      } else {
        return {
                TAG: "Ok",
                _0: brokerage
              };
      }
    })
};

var validators_teamName = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (function (param) {
      var teamName = param.teamName;
      if (teamName === "") {
        return {
                TAG: "Error",
                _0: "IsRequired"
              };
      } else {
        return {
                TAG: "Ok",
                _0: teamName
              };
      }
    })
};

var validators = {
  teamSize: validators_teamSize,
  website: validators_website,
  brokerage: validators_brokerage,
  teamName: validators_teamName
};

function initialFieldsStatuses(_input) {
  return {
          teamSize: "Pristine",
          website: "Pristine",
          brokerage: "Pristine",
          teamName: "Pristine"
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            teamSize: "Pristine",
            website: "Pristine",
            brokerage: "Pristine",
            teamName: "Pristine"
          },
          collectionsStatuses: undefined,
          formStatus: "Editing",
          submissionStatus: "NeverSubmitted"
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match = fieldsStatuses.teamSize;
  var tmp;
  tmp = typeof match !== "object" ? validators.teamSize.validate(input) : match._0;
  var match$1 = fieldsStatuses.website;
  var tmp$1;
  tmp$1 = typeof match$1 !== "object" ? validators.website.validate(input) : match$1._0;
  var match$2 = fieldsStatuses.brokerage;
  var tmp$2;
  tmp$2 = typeof match$2 !== "object" ? validators.brokerage.validate(input) : match$2._0;
  var match$3 = fieldsStatuses.teamName;
  var tmp$3;
  tmp$3 = typeof match$3 !== "object" ? validators.teamName.validate(input) : match$3._0;
  var teamSizeResult = tmp;
  var teamSizeResult$1;
  if (teamSizeResult.TAG === "Ok") {
    var websiteResult = tmp$1;
    if (websiteResult.TAG === "Ok") {
      var brokerageResult = tmp$2;
      if (brokerageResult.TAG === "Ok") {
        var teamNameResult = tmp$3;
        if (teamNameResult.TAG === "Ok") {
          return {
                  TAG: "Valid",
                  output: {
                    teamName: teamNameResult._0,
                    brokerage: brokerageResult._0,
                    website: websiteResult._0,
                    teamSize: teamSizeResult._0
                  },
                  fieldsStatuses: {
                    teamSize: {
                      TAG: "Dirty",
                      _0: teamSizeResult,
                      _1: "Shown"
                    },
                    website: {
                      TAG: "Dirty",
                      _0: websiteResult,
                      _1: "Shown"
                    },
                    brokerage: {
                      TAG: "Dirty",
                      _0: brokerageResult,
                      _1: "Shown"
                    },
                    teamName: {
                      TAG: "Dirty",
                      _0: teamNameResult,
                      _1: "Shown"
                    }
                  },
                  collectionsStatuses: undefined
                };
        }
        teamSizeResult$1 = teamSizeResult;
      } else {
        teamSizeResult$1 = teamSizeResult;
      }
    } else {
      teamSizeResult$1 = teamSizeResult;
    }
  } else {
    teamSizeResult$1 = teamSizeResult;
  }
  return {
          TAG: "Invalid",
          fieldsStatuses: {
            teamSize: {
              TAG: "Dirty",
              _0: teamSizeResult$1,
              _1: "Shown"
            },
            website: {
              TAG: "Dirty",
              _0: tmp$1,
              _1: "Shown"
            },
            brokerage: {
              TAG: "Dirty",
              _0: tmp$2,
              _1: "Shown"
            },
            teamName: {
              TAG: "Dirty",
              _0: tmp$3,
              _1: "Shown"
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action !== "object") {
            switch (action) {
              case "BlurTeamSizeField" :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.teamSize, validators_teamSize, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  teamSize: status,
                                  website: init.website,
                                  brokerage: init.brokerage,
                                  teamName: init.teamName
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurWebsiteField" :
                  var result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.website, validators_website, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  teamSize: init.teamSize,
                                  website: status,
                                  brokerage: init.brokerage,
                                  teamName: init.teamName
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurBrokerageField" :
                  var result$2 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.brokerage, validators_brokerage, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  teamSize: init.teamSize,
                                  website: init.website,
                                  brokerage: status,
                                  teamName: init.teamName
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "BlurTeamNameField" :
                  var result$3 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.teamName, validators_teamName, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  teamSize: init.teamSize,
                                  website: init.website,
                                  brokerage: init.brokerage,
                                  teamName: status
                                };
                        }));
                  if (result$3 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              case "Submit" :
                  var match = state.formStatus;
                  if (typeof match === "object" && match.TAG === "Submitting") {
                    return "NoUpdate";
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== "Valid") {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: "Editing",
                              submissionStatus: "AttemptedToSubmit"
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: "UpdateWithSideEffects",
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: "Submitting",
                              _0: tmp
                            },
                            submissionStatus: "AttemptedToSubmit"
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              onSubmit(output, {
                                    notifyOnSuccess: (function (input) {
                                        dispatch({
                                              TAG: "SetSubmittedStatus",
                                              _0: input
                                            });
                                      }),
                                    notifyOnFailure: (function (error) {
                                        dispatch({
                                              TAG: "SetSubmissionFailedStatus",
                                              _0: error
                                            });
                                      }),
                                    reset: (function () {
                                        dispatch("Reset");
                                      }),
                                    dismissSubmissionResult: (function () {
                                        dispatch("DismissSubmissionResult");
                                      })
                                  });
                            })
                        };
                  break;
              case "DismissSubmissionError" :
                  var match$2 = state.formStatus;
                  if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
                    return "NoUpdate";
                  } else {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Editing",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case "DismissSubmissionResult" :
                  var match$3 = state.formStatus;
                  if (typeof match$3 !== "object") {
                    if (match$3 === "Editing") {
                      return "NoUpdate";
                    }
                    
                  } else if (match$3.TAG === "Submitting") {
                    return "NoUpdate";
                  }
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: "Editing",
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "Reset" :
                  return {
                          TAG: "Update",
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG) {
              case "UpdateTeamSizeField" :
                  var nextInput = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.teamSize, state.submissionStatus, validators_teamSize, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            teamSize: status,
                                            website: init.website,
                                            brokerage: init.brokerage,
                                            teamName: init.teamName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateWebsiteField" :
                  var nextInput$1 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, state.fieldsStatuses.website, state.submissionStatus, validators_website, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            teamSize: init.teamSize,
                                            website: status,
                                            brokerage: init.brokerage,
                                            teamName: init.teamName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateBrokerageField" :
                  var nextInput$2 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$2, state.fieldsStatuses.brokerage, state.submissionStatus, validators_brokerage, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            teamSize: init.teamSize,
                                            website: init.website,
                                            brokerage: status,
                                            teamName: init.teamName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "UpdateTeamNameField" :
                  var nextInput$3 = action._0(state.input);
                  return {
                          TAG: "Update",
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$3, state.fieldsStatuses.teamName, state.submissionStatus, validators_teamName, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            teamSize: init.teamSize,
                                            website: init.website,
                                            brokerage: init.brokerage,
                                            teamName: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "SetSubmittedStatus" :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                teamSize: "Pristine",
                                website: "Pristine",
                                brokerage: "Pristine",
                                teamName: "Pristine"
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Submitted",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                teamSize: "Pristine",
                                website: "Pristine",
                                brokerage: "Pristine",
                                teamName: "Pristine"
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: "Submitted",
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case "SetSubmissionFailedStatus" :
                  return {
                          TAG: "Update",
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: "SubmissionFailed",
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case "MapSubmissionError" :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 !== "object") {
                    return "NoUpdate";
                  }
                  if (error$1.TAG !== "Submitting") {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: "SubmissionFailed",
                                _0: map(error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: "Update",
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: "Submitting",
                                _0: Caml_option.some(map(Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return "NoUpdate";
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 !== "object" || match$1.TAG !== "Submitting" ? false : true;
  return {
          updateTeamSize: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateTeamSizeField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateWebsite: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateWebsiteField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateBrokerage: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateBrokerageField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          updateTeamName: (function (nextInputFn, nextValue) {
              dispatch({
                    TAG: "UpdateTeamNameField",
                    _0: (function (__x) {
                        return nextInputFn(__x, nextValue);
                      })
                  });
            }),
          blurTeamSize: (function () {
              dispatch("BlurTeamSizeField");
            }),
          blurWebsite: (function () {
              dispatch("BlurWebsiteField");
            }),
          blurBrokerage: (function () {
              dispatch("BlurBrokerageField");
            }),
          blurTeamName: (function () {
              dispatch("BlurTeamNameField");
            }),
          teamSizeResult: Formality.exposeFieldResult(state.fieldsStatuses.teamSize),
          websiteResult: Formality.exposeFieldResult(state.fieldsStatuses.website),
          brokerageResult: Formality.exposeFieldResult(state.fieldsStatuses.brokerage),
          teamNameResult: Formality.exposeFieldResult(state.fieldsStatuses.teamName),
          input: state.input,
          status: state.formStatus,
          dirty: (function () {
              var match = state.fieldsStatuses;
              var tmp = match.teamSize;
              if (typeof tmp === "object") {
                return true;
              }
              var tmp$1 = match.website;
              if (typeof tmp$1 === "object") {
                return true;
              }
              var tmp$2 = match.brokerage;
              if (typeof tmp$2 === "object") {
                return true;
              }
              var tmp$3 = match.teamName;
              if (typeof tmp$3 !== "object") {
                return false;
              } else {
                return true;
              }
            }),
          valid: (function () {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === "Valid") {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function () {
              dispatch("Submit");
            }),
          dismissSubmissionError: (function () {
              dispatch("DismissSubmissionError");
            }),
          dismissSubmissionResult: (function () {
              dispatch("DismissSubmissionResult");
            }),
          mapSubmissionError: (function (map) {
              dispatch({
                    TAG: "MapSubmissionError",
                    _0: map
                  });
            }),
          reset: (function () {
              dispatch("Reset");
            })
        };
}

var Config = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

var convertFragment = TeamMarketingProfileBasicInfoSettings_form_agentMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, TeamMarketingProfileBasicInfoSettings_form_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(TeamMarketingProfileBasicInfoSettings_form_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, TeamMarketingProfileBasicInfoSettings_form_agentMarketingProfile_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(TeamMarketingProfileBasicInfoSettings_form_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

var Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertVariables = TeamMarketingProfileBasicInfoSettingsMutation_graphql.Internal.convertVariables;

var convertResponse = TeamMarketingProfileBasicInfoSettingsMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = TeamMarketingProfileBasicInfoSettingsMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, TeamMarketingProfileBasicInfoSettingsMutation_graphql.node, convertResponse, convertWrapRawResponse);

var use$1 = RescriptRelay_Mutation.useMutation(convertVariables, TeamMarketingProfileBasicInfoSettingsMutation_graphql.node, convertResponse, convertWrapRawResponse);

var Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$1
};

function initialInputFromFragment(fragment) {
  return {
          teamName: fragment.teamName,
          brokerage: Core__Option.getOr(fragment.brokerage, ""),
          website: Core__Option.getOr(Core__Option.map(fragment.website, Scalars.$$URL.toString), ""),
          teamSize: Core__Option.getOr(Core__Option.map(fragment.teamSize, (function (v) {
                      return v.toString();
                    })), "")
        };
}

function messageToString(v) {
  if (v === "InvalidURL") {
    return "must be a valid URL";
  } else if (v === "IsRequired") {
    return "is required";
  } else {
    return "must be a number";
  }
}

function TeamMarketingProfileBasicInfoSettings$Form$FieldValidationMessage(props) {
  return JsxRuntime.jsx(FormalityUI.FieldValidationMessage.make, {
              messageToString: messageToString,
              result: props.result
            });
}

var FieldValidationMessage = {
  make: TeamMarketingProfileBasicInfoSettings$Form$FieldValidationMessage
};

function TeamMarketingProfileBasicInfoSettings$Form$InputField(props) {
  var status = props.status;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(Form__Label.make, {
                            labelText: props.labelText
                          }),
                      className: "pt-2"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(Form__Input.make, {
                              type: props._type,
                              onChange: props.onChange,
                              onBlur: props.onBlur,
                              status: FormalityUI.UIKitStatus.ofOptFieldResult(status),
                              value: props.value
                            }),
                        Core__Option.getOr(Core__Option.map(props.helpText, (function (text) {
                                    return JsxRuntime.jsx("div", {
                                                children: text,
                                                className: "text-base text-gray-500"
                                              });
                                  })), null),
                        JsxRuntime.jsx(TeamMarketingProfileBasicInfoSettings$Form$FieldValidationMessage, {
                              result: status
                            })
                      ],
                      className: "mt-2 sm:col-span-2 sm:mt-0 sm:max-w-xs space-y-3"
                    })
              ],
              className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6"
            });
}

var InputField = {
  make: TeamMarketingProfileBasicInfoSettings$Form$InputField
};

function TeamMarketingProfileBasicInfoSettings$Form(props) {
  var marketingProfile = use(props.marketingProfile);
  var match = use$1();
  var mutate = match[0];
  var form = useForm(initialInputFromFragment(marketingProfile), (function (param, param$1) {
          var notifyOnFailure = param$1.notifyOnFailure;
          var notifyOnSuccess = param$1.notifyOnSuccess;
          mutate({
                input: {
                  brokerage: param.brokerage,
                  teamName: param.teamName,
                  teamSize: param.teamSize,
                  website: param.website
                }
              }, undefined, undefined, undefined, (function (param, param$1) {
                  var result = param.updateTeamMarketingProfileBasicInfo;
                  if (result !== undefined && result.__typename === "TeamMarketingProfileBasicInfoUpdated") {
                    return notifyOnSuccess(undefined);
                  } else {
                    return notifyOnFailure();
                  }
                }), (function (param) {
                  notifyOnFailure();
                }), undefined);
        }));
  var match$1 = form.status;
  var tmp;
  tmp = typeof match$1 !== "object" ? (
      match$1 === "Editing" ? null : JsxRuntime.jsx(Alert.Success.make, {
              title: "Your account was updated"
            })
    ) : (
      match$1.TAG === "Submitting" ? null : JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Alert.$$Error.make, {
                    title: "There was an error updating your account. Please try again"
                  }),
              className: "mt-4"
            })
    );
  return JsxRuntime.jsx("form", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(TeamMarketingProfileBasicInfoSettings$Form$InputField, {
                                    onChange: (function ($$event) {
                                        form.updateTeamName((function (input, value) {
                                                return {
                                                        teamName: value,
                                                        brokerage: input.brokerage,
                                                        website: input.website,
                                                        teamSize: input.teamSize
                                                      };
                                              }), $$event.target.value);
                                      }),
                                    onBlur: (function (param) {
                                        form.blurTeamName();
                                      }),
                                    value: form.input.teamName,
                                    status: form.teamNameResult,
                                    labelText: "Team name"
                                  }),
                              JsxRuntime.jsx(TeamMarketingProfileBasicInfoSettings$Form$InputField, {
                                    onChange: (function ($$event) {
                                        form.updateBrokerage((function (input, value) {
                                                return {
                                                        teamName: input.teamName,
                                                        brokerage: value,
                                                        website: input.website,
                                                        teamSize: input.teamSize
                                                      };
                                              }), $$event.target.value);
                                      }),
                                    onBlur: (function (param) {
                                        form.blurBrokerage();
                                      }),
                                    value: form.input.brokerage,
                                    status: form.brokerageResult,
                                    labelText: "Brokerage"
                                  }),
                              JsxRuntime.jsx(TeamMarketingProfileBasicInfoSettings$Form$InputField, {
                                    onChange: (function ($$event) {
                                        form.updateWebsite((function (input, value) {
                                                return {
                                                        teamName: input.teamName,
                                                        brokerage: input.brokerage,
                                                        website: value,
                                                        teamSize: input.teamSize
                                                      };
                                              }), $$event.target.value);
                                      }),
                                    onBlur: (function (param) {
                                        form.blurWebsite();
                                      }),
                                    value: form.input.website,
                                    status: form.websiteResult,
                                    labelText: "Website"
                                  }),
                              JsxRuntime.jsx(TeamMarketingProfileBasicInfoSettings$Form$InputField, {
                                    onChange: (function ($$event) {
                                        form.updateTeamSize((function (input, value) {
                                                return {
                                                        teamName: input.teamName,
                                                        brokerage: input.brokerage,
                                                        website: input.website,
                                                        teamSize: value
                                                      };
                                              }), $$event.target.value);
                                      }),
                                    onBlur: (function (param) {
                                        form.blurTeamSize();
                                      }),
                                    value: form.input.teamSize,
                                    status: form.teamSizeResult,
                                    labelText: "Team size",
                                    helpText: "Optional. Sharing the number of agents on your team will help us serve teams better.",
                                    _type: "number"
                                  })
                            ],
                            className: "space-y-8 border-b border-zinc-200 pb-12 sm:space-y-0 sm:divide-y sm:divide-zinc-200 sm:pb-0"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                                    href: Scalars.$$URL.toString(marketingProfile.publicUrl),
                                    target: "_blank",
                                    children: "View Profile"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                                            disabled: form.submitting,
                                            children: "Save changes"
                                          }),
                                      JsxRuntime.jsx("div", {
                                            children: tmp,
                                            role: "status"
                                          })
                                    ],
                                    className: "flex flex-col items-end gap-3"
                                  })
                            ],
                            className: "flex justify-between items-baseline"
                          })
                    ],
                    className: "space-y-6"
                  }),
              onSubmit: (function ($$event) {
                  $$event.preventDefault();
                  form.submit();
                })
            });
}

var Form = {
  Config: Config,
  Fragment: Fragment,
  Mutation: Mutation,
  initialInputFromFragment: initialInputFromFragment,
  messageToString: messageToString,
  FieldValidationMessage: FieldValidationMessage,
  InputField: InputField,
  make: TeamMarketingProfileBasicInfoSettings$Form
};

function TeamMarketingProfileBasicInfoSettings$Header(props) {
  var displayName = MarketingProfileSubpages.Page.Team.useDisplayName();
  var breadcrumbs = [
    {
      name: "Team Marketing Profile",
      href: "/account/team_marketing_profile"
    },
    {
      name: displayName("BasicInfo"),
      href: MarketingProfileSubpages.Page.Team.path("BasicInfo")
    }
  ];
  return JsxRuntime.jsxs("header", {
              children: [
                JsxRuntime.jsx(Breadcrumbs.make, {
                      pages: breadcrumbs
                    }),
                JsxRuntime.jsx("h2", {
                      children: displayName("BasicInfo"),
                      className: "text-zinc-800 text-3xl font-medium"
                    })
              ],
              className: "space-y-3 border-b pb-2"
            });
}

var Header = {
  make: TeamMarketingProfileBasicInfoSettings$Header
};

var convertVariables$1 = TeamMarketingProfileBasicInfoSettingsQuery_graphql.Internal.convertVariables;

var convertResponse$1 = TeamMarketingProfileBasicInfoSettingsQuery_graphql.Internal.convertResponse;

var convertWrapRawResponse$1 = TeamMarketingProfileBasicInfoSettingsQuery_graphql.Internal.convertWrapRawResponse;

var use$2 = RescriptRelay_Query.useQuery(convertVariables$1, TeamMarketingProfileBasicInfoSettingsQuery_graphql.node, convertResponse$1);

var useLoader = RescriptRelay_Query.useLoader(convertVariables$1, TeamMarketingProfileBasicInfoSettingsQuery_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded = RescriptRelay_Query.usePreloaded(TeamMarketingProfileBasicInfoSettingsQuery_graphql.node, convertResponse$1, (function (prim) {
        return prim;
      }));

var $$fetch = RescriptRelay_Query.$$fetch(TeamMarketingProfileBasicInfoSettingsQuery_graphql.node, convertResponse$1, convertVariables$1);

var fetchPromised = RescriptRelay_Query.fetchPromised(TeamMarketingProfileBasicInfoSettingsQuery_graphql.node, convertResponse$1, convertVariables$1);

var retain = RescriptRelay_Query.retain(TeamMarketingProfileBasicInfoSettingsQuery_graphql.node, convertVariables$1);

var Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  use: use$2,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  $$fetch: $$fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function TeamMarketingProfileBasicInfoSettings(props) {
  var match = use$2(undefined, undefined, undefined, undefined);
  var marketingProfile = match.currentAccountV5.marketingProfile;
  if (marketingProfile.__typename === "TeamMarketingProfile") {
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(TeamMarketingProfileBasicInfoSettings$Header, {}),
                        JsxRuntime.jsx(TeamMarketingProfileBasicInfoSettings$Form, {
                              marketingProfile: marketingProfile.fragmentRefs
                            })
                      ],
                      className: "space-y-8 sm:space-y-0"
                    }),
                className: "bg-white p-6 shadow-sm rounded space-y-8"
              });
  } else {
    return UnselectedUnionMemberError.raise("Unselected union member: " + marketingProfile._0);
  }
}

var make = TeamMarketingProfileBasicInfoSettings;

exports.Form = Form;
exports.Header = Header;
exports.Query = Query;
exports.make = make;
/* commitMutation Not a pure module */
